import { useMemo, useState } from 'react';
import { TreeSelect, message } from 'antd';
const { SHOW_PARENT, SHOW_ALL, SHOW_CHILD } = TreeSelect;
const convertTreeData = function (data, convertType) {
    const tmpObj = {};
    const result = [];
    if (!data)
        return result;
    const idProperty = convertType.id;
    const keyProperty = convertType.key || idProperty;
    const parentIdProperty = convertType.pId;
    const childrenProperty = convertType.children;
    const cloneData = JSON.parse(JSON.stringify(data));
    const length = cloneData.length;
    for (let i = 0, len = length; i < len; i++) {
        const item = cloneData[i];
        tmpObj[item[keyProperty]] = item;
    }
    for (var i = 0, len = length; i < len; i++) {
        const child = cloneData[i];
        const parent = tmpObj[child[parentIdProperty]];
        if (parent) {
            parent[childrenProperty] = parent[childrenProperty] ? parent[childrenProperty] : [];
            const resultChild = genConvertProp(child, convertType);
            parent[childrenProperty].push(resultChild);
        }
        else {
            const resultChild = genConvertProp(child, convertType);
            result.push(resultChild);
        }
    }
    return result;
};
const genConvertProp = function (data, map) {
    const tmpData = JSON.parse(JSON.stringify(data));
    for (const key in map) {
        const value = map[key];
        tmpData[key] = tmpData[value];
        delete tmpData[value];
    }
    return tmpData;
};
const GrtSelectTree = (prop) => {
    const [treeData, setTreeData] = useState(prop.treeData);
    const [treeExpandedKeys, setTreeExpandedKeys] = useState(prop.treeExpandedKeys || []);
    const initValue = prop.initValue || [];
    let [value, setValue] = useState(initValue);
    const convertData = prop.convertData;
    useMemo(function () {
        if (convertData.title && convertData.value) {
            const resultTreeData = convertTreeData(treeData, convertData);
            setTreeData(resultTreeData);
        }
    }, [prop.treeData]);
    const filterTreeNode = (inputValue, treeNode) => {
        const flag = treeNode.title.indexOf(inputValue) !== -1;
        if (flag) {
            const set = new Set(treeExpandedKeys);
            if (!treeNode.children) {
                set.add(treeNode.key);
                setTreeExpandedKeys(Array.from(set));
            }
        }
        return flag;
    };
    const onTreeExpand = function (expandedKeys) {
        const set = new Set(expandedKeys);
        setTreeExpandedKeys(Array.from(set));
        if (prop.onTreeExpand && typeof prop.onTreeExpand === "function") {
            prop.onTreeExpand(expandedKeys);
        }
    };
    const onSelect = function (val, option) {
        if (prop.onSelect && typeof prop.onSelect === "function") {
            prop.onSelect(val, option);
        }
    };
    const onChange = function (val, label, extra) {
        if (prop.maxLength && val.length > prop.maxLength) {
            message.error("最多选择数量超过限制，最多选择" + prop.maxLength);
            return;
        }
        setValue(val);
        if (prop.onChange && typeof prop.onChange === "function") {
            prop.onChange(val, label, extra);
        }
    };
    const onDropdownVisibleChange = function (open) {
        if (prop.onDropdownVisibleChange && typeof prop.onDropdownVisibleChange === "function") {
            prop.onDropdownVisibleChange(open);
        }
    };
    const treeProps = {
        treeData,
        value,
        onDropdownVisibleChange,
        treeCheckStrictly: true,
        onTreeExpand,
        onSelect,
        onChange,
        filterTreeNode: filterTreeNode,
        multiple: typeof prop.multiple !== "undefined" ? prop.multiple : false,
        treeDefaultExpandAll: typeof prop.treeDefaultExpandAll !== "undefined" ? prop.treeDefaultExpandAll : false,
        treeCheckable: typeof prop.treeCheckable !== "undefined" ? prop.treeCheckable : false,
        showCheckedStrategy: typeof prop.showCheckedStrategy !== "undefined" ? prop.showCheckedStrategy : SHOW_PARENT,
        placeholder: prop.placeholder,
        style: prop.style,
        showSearch: typeof prop.showSearch !== "undefined" ? prop.showSearch : true,
    };
    if (treeExpandedKeys && treeExpandedKeys.length) {
        treeProps.treeExpandedKeys = treeExpandedKeys;
    }
    if (prop.treeDefaultExpandedKeys && prop.treeDefaultExpandedKeys.length) {
        treeProps.treeDefaultExpandedKeys = prop.treeDefaultExpandedKeys;
    }
    return <TreeSelect {...treeProps}/>;
};
export default GrtSelectTree;
